export enum PhoneNumberMaskEnum {
  CountryCode9Digits = '+## (##) #####-####',
  CountryCode8Digits = '+## (##) ####-####',
  NoCountryCode9Digits = '(##) #####-####',
  NoCountryCode8Digits = '(##) ####-####',
}
